/* Saved Designs drawer behaviour (the wishlist until 2026-09-25) (snippets/popup-wishlist.liquid). Loaded once
   from layout/theme.liquid after ac-cart.js.

   The theme's store-lists engine (theme.js) stays the single wishlist
   store: entries are { variantId: handle } pairs in localStorage (guests)
   mirrored to the customer lists app (signed in), hearts and the header
   count are its checkProductStatus / updateHeaderCount, and the popup
   controller (theme.StoreLists.popups.wishlist) reads the entries, fetches
   /products/<handle>.js for each, and toggles the filled / empty blocks.
   This file extends two of that controller's methods on the instance:

   - _getProducts: same output shape, plus a per-handle status so a design
     that could not be fetched is told apart from one that no longer exists
   - _resultToHTML: when the target list is inside the drawer (.ac-wd) the
     rows come from the drawer's own <template>; anywhere else (the full
     wishlist popup, compare) the theme's rows are untouched

   Remove is handled here in the capture phase so the theme's body-delegated
   handler (which re-fetches every product) does not double up: the entry
   goes through the engine's removeItem, so persistence, hearts, header
   count and the customer sync are the theme's; the row is then dropped
   without a refetch, the empty state appears after the last one, focus
   moves on and the change is announced. A failed removal keeps the row,
   re-enables Remove and shows an inline message.

   Dialog semantics (focus, Tab cycling, inert page, chat bubble, focus
   return) come from the shared registry in ac-cart.js. */
(function () {
  'use strict';

  var SEL = {
    root: '.ac-wd',
    items: '[data-ac-wd-items]',
    row: '[data-ac-wd-item]',
    rowTemplate: 'template[data-ac-wd-row]',
    live: '[data-ac-wd-live]',
    remove: '[data-ac-wd-remove]',
    retry: '[data-ac-wd-retry]',
    filled: '.popup-wishlist__content',
    empty: '.popup-wishlist__empty',
    emptyTitle: '#ac-wd-empty-title',
    count: '[data-js-popup-wishlist-count]',
    error: '[data-ac-wd-error]'
  };

  var COPY = {
    gone: 'This design is no longer available',
    loadFailed: 'This design could not be loaded',
    loadHint: 'Check your connection and try again.',
    retry: 'Retry',
    unavailable: 'Currently unavailable',
    variantUnavailable: 'This option is currently unavailable',
    variantGone: 'The saved option is no longer offered',
    from: 'From ',
    removeFailed: "Couldn't remove this design. Please try again.",
    removed: ' removed from saved designs.',
    left: ' saved design',
    leftPlural: ' saved designs'
  };

  function root() { return document.querySelector(SEL.root); }
  function engineReady() {
    var t = window.theme;
    return !!(window.jQuery && t && t.StoreLists && t.StoreLists.popups && t.StoreLists.popups.wishlist && t.StoreLists.lists && t.StoreLists.lists.wishlist);
  }

  /* ---- helpers ----------------------------------------------------------- */

  function announce(message) {
    var r = root();
    var live = r && r.querySelector(SEL.live);
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = message; }, 60);
  }

  function setBusy(row, busy) {
    row.classList.toggle('is-busy', busy);
    if (busy) row.setAttribute('aria-busy', 'true'); else row.removeAttribute('aria-busy');
  }

  function showError(row, message) {
    var el = row.querySelector(SEL.error);
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }
  function clearError(row) {
    var el = row.querySelector(SEL.error);
    if (el) { el.hidden = true; el.textContent = ''; }
  }

  function resize(src, size) {
    return window.Shopify && typeof Shopify.resizeImage === 'function' ? Shopify.resizeImage(src, size) : src;
  }

  function storedCount() {
    try {
      var list = theme.StoreLists.lists.wishlist;
      var raw = localStorage.getItem(list.current_storage);
      return raw ? JSON.parse(raw).length : 0;
    } catch (e) { return null; }
  }

  function syncCount(n) {
    var r = root();
    var el = r && r.querySelector(SEL.count);
    if (!el) return;
    var format = (theme.strings && theme.strings.general && theme.strings.general.popups && theme.strings.general.popups.wishlist && theme.strings.general.popups.wishlist.count) || '({{ count }})';
    el.textContent = format.replace('{{ count }}', n);
  }

  function showEmpty() {
    var r = root();
    if (!r) return;
    var filled = r.querySelector(SEL.filled), empty = r.querySelector(SEL.empty);
    if (filled) filled.classList.add('d-none-important');
    if (empty) empty.classList.remove('d-none-important');
  }

  function focusEl(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  /* ---- rows -------------------------------------------------------------- */

  function fillRow(row, id, handle, product, status) {
    var thumb = row.querySelector('.ac-wd-item__thumb');
    var img = row.querySelector('[data-ac-wd-image]');
    var fallback = row.querySelector('[data-ac-wd-image-fallback]');
    var title = row.querySelector('[data-ac-wd-title]');
    var variantEl = row.querySelector('[data-ac-wd-variant]');
    var priceEl = row.querySelector('[data-ac-wd-price]');
    var note = row.querySelector('[data-ac-wd-note]');
    var cta = row.querySelector('[data-ac-wd-cta]');
    var ctaName = row.querySelector('[data-ac-wd-cta-name]');
    var removeName = row.querySelector('[data-ac-wd-remove-name]');
    var links = row.querySelectorAll('[data-ac-wd-link]');

    row.setAttribute('data-product-handle', handle);
    row.setAttribute('data-product-variant-id', id);

    function showFallback() {
      img.hidden = true;
      fallback.hidden = false;
    }

    if (!product) {
      var gone = status !== 'error';
      var label = gone ? COPY.gone : COPY.loadFailed;
      row.classList.add('ac-wd-item--unavailable');
      row.setAttribute('data-title', label);
      var plain = document.createElement('span');
      plain.textContent = label;
      title.parentNode.replaceChild(plain, title);
      thumb.removeAttribute('href');
      showFallback();
      priceEl.parentNode.remove();
      cta.remove();
      if (!gone) {
        note.textContent = COPY.loadHint + ' ';
        var retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'ac-wd-item__retry';
        retry.setAttribute('data-ac-wd-retry', '');
        retry.textContent = COPY.retry;
        note.appendChild(retry);
        note.hidden = false;
      }
      removeName.textContent = ' ' + label;
      return row;
    }

    var variant = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(id)) { variant = product.variants[i]; break; }
    }
    var variantMissing = !variant;
    if (variantMissing) variant = product.variants[0];

    var url = product.url || ('/products/' + encodeURIComponent(handle));
    if (!variantMissing) url += (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variant.id;
    for (var l = 0; l < links.length; l++) links[l].setAttribute('href', url);

    title.textContent = product.title;
    row.setAttribute('data-title', product.title);

    var image = (variant.featured_image && variant.featured_image.src) || product.featured_image || (product.images && product.images[0]) || null;
    if (image) {
      img.src = resize(image, '220x');
      img.srcset = resize(image, '220x') + ' 220w, ' + resize(image, '330x') + ' 330w, ' + resize(image, '440x') + ' 440w';
      img.sizes = '128px';
      img.hidden = false;
      img.addEventListener('error', showFallback, { once: true });
    } else {
      showFallback();
    }

    if (variant.title && variant.title !== 'Default Title') {
      variantEl.textContent = variant.title;
      variantEl.hidden = false;
    }

    var showFrom = variantMissing && product.price_varies;
    theme.ProductPrice.insert(window.jQuery(priceEl), showFrom ? product.price_min : variant.price, showFrom ? null : variant.compare_at_price);
    /* The theme's JS money format is the bare "$29.99"; the product page, the
       cart drawer (Liquid money_with_currency) and the approved mockup all
       carry the code ("$29.99 USD"). Add it unless the format already has it. */
    var code = window.Shopify && Shopify.currency && Shopify.currency.active;
    if (code && priceEl.textContent.indexOf(code) === -1) {
      (priceEl.lastElementChild || priceEl).appendChild(document.createTextNode(' ' + code));
    }
    if (showFrom) {
      var from = document.createElement('span');
      from.className = 'ac-wd-item__from';
      from.textContent = COPY.from;
      priceEl.insertBefore(from, priceEl.firstChild);
    }

    var noteText = '';
    if (product.available === false) noteText = COPY.unavailable;
    else if (variantMissing) noteText = COPY.variantGone;
    else if (variant.available === false) noteText = COPY.variantUnavailable;
    if (noteText) { note.textContent = noteText; note.hidden = false; }

    ctaName.textContent = ': ' + product.title;
    removeName.textContent = ' ' + product.title;
    return row;
  }

  function renderRows(container, data) {
    var r = root();
    var tpl = r && r.querySelector(SEL.rowTemplate);
    if (!tpl) return;
    var frag = document.createDocumentFragment();
    var status = data.status || {};
    var n = 0;
    for (var i = 0; i < data.params.length; i++) {
      var entry = data.params[i];
      for (var id in entry) {
        if (!Object.prototype.hasOwnProperty.call(entry, id)) continue;
        var handle = entry[id];
        var product = null;
        for (var p = 0; p < data.products.length; p++) {
          if (data.products[p].handle === handle) { product = data.products[p]; break; }
        }
        var row = tpl.content.firstElementChild.cloneNode(true);
        frag.appendChild(fillRow(row, id, handle, product, status[handle]));
        n++;
      }
    }
    container.innerHTML = '';
    container.appendChild(frag);
    syncCount(n);
  }

  /* ---- engine extension -------------------------------------------------- */

  function install() {
    var popup = theme.StoreLists.popups.wishlist;
    if (popup._acWishlistPatched) return;
    popup._acWishlistPatched = true;

    /* The engine only refreshes the header count for guests after an add or
       remove; on a fresh page load the counter stays at the server-rendered 0
       while the hearts are already filled. Bring it in line once. */
    if (!theme.customer) theme.StoreLists.lists.wishlist.updateHeaderCount();
    var origRender = popup._resultToHTML;

    popup._getProducts = function (items, callback) {
      var handles = [];
      for (var i = 0; i < items.length; i++) {
        for (var id in items[i]) {
          if (Object.prototype.hasOwnProperty.call(items[i], id) && handles.indexOf(items[i][id]) === -1) handles.push(items[i][id]);
        }
      }
      Promise.all(handles.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
          .then(function (response) {
            if (response.ok) return response.json().then(function (product) { return { handle: handle, product: product }; });
            return { handle: handle, product: null, status: response.status === 404 ? 'gone' : 'error' };
          })
          .catch(function () { return { handle: handle, product: null, status: 'error' }; });
      })).then(function (results) {
        var products = [], status = {};
        results.forEach(function (res) {
          if (res.product) products.push(res.product); else status[res.handle] = res.status;
        });
        callback({ params: items, products: products, status: status });
      });
    };

    popup._resultToHTML = function ($items, data, callback) {
      if (!$items.closest(SEL.root).length) return origRender.call(this, $items, data, callback);
      renderRows($items[0], data);
      if (theme.MultiCurrency) theme.MultiCurrency.update();
      if (callback) callback();
    };
  }

  (function waitForEngine(tries) {
    if (engineReady()) { install(); return; }
    if (tries > 100) return;
    window.setTimeout(function () { waitForEngine(tries + 1); }, 100);
  })(0);

  if (window.acDrawerDialog) {
    window.acDrawerDialog.register('wishlist', { root: SEL.root, close: '.ac-wd__close' });
    window.acDrawerDialog.register('wishlist-full', { root: '.popup-wishlist-full', close: '.popup-wishlist-full__close' });
  }

  /* ---- remove and retry (capture: keeps the theme's own remove from running too) */

  function removeRow(row) {
    if (row.classList.contains('is-busy')) return;
    var handle = row.getAttribute('data-product-handle');
    var id = +row.getAttribute('data-product-variant-id');
    var label = row.getAttribute('data-title') || '';
    var button = row.querySelector(SEL.remove);
    var container = row.parentNode;
    var next = row.nextElementSibling || row.previousElementSibling;

    clearError(row);
    setBusy(row, true);
    if (button) button.disabled = true;

    var ok = false;
    try {
      theme.StoreLists.lists.wishlist.removeItem(id, handle, function () { ok = true; });
    } catch (e) { ok = false; }

    if (!ok) {
      setBusy(row, false);
      if (button) button.disabled = false;
      showError(row, COPY.removeFailed);
      return;
    }

    /* Other surfaces showing the same entry (the full wishlist page cards),
       as the theme's own remove callback does. */
    window.jQuery('[data-js-store-lists-product-wishlist][data-product-handle="' + handle + '"][data-product-variant-id="' + id + '"]').each(function () {
      var $el = window.jQuery(this);
      ($el.parent('[class*="col"]').length ? $el.parent() : $el).remove();
    });

    /* Slide the row out (translate + collapse), then take it out of the DOM.
       The stored list is already updated, so the count and the empty state
       are right even if the animation is interrupted. Reduced motion skips it. */
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function finish() {
      if (!row.parentNode) return;
      row.remove();
      var remaining = storedCount();
      if (remaining === null) remaining = container.children.length;
      syncCount(remaining);

      if (remaining === 0 || !container.children.length) {
        showEmpty();
        focusEl(document.querySelector(SEL.emptyTitle));
      } else if (next && next.parentNode) {
        focusEl(next.querySelector('[data-ac-wd-title]') || next.querySelector(SEL.remove));
      }
      announce(label + COPY.removed + ' ' + remaining + (remaining === 1 ? COPY.left : COPY.leftPlural) + '.');
    }
    if (reduce) { finish(); return; }
    row.style.height = row.getBoundingClientRect().height + 'px';
    row.classList.add('is-leaving');
    var done = false;
    function once() { if (done) return; done = true; finish(); }
    row.addEventListener('transitionend', function (e) { if (e.propertyName === 'height') once(); });
    window.setTimeout(once, 520);
    window.requestAnimationFrame(function () { row.classList.add('is-gone'); });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var remove = event.target.closest(SEL.remove);
    if (remove && remove.closest(SEL.root)) {
      event.preventDefault();
      event.stopPropagation();
      if (!engineReady()) return;
      removeRow(remove.closest(SEL.row));
      return;
    }
    var retry = event.target.closest(SEL.retry);
    if (retry && retry.closest(SEL.root) && engineReady()) {
      event.preventDefault();
      var row = retry.closest(SEL.row);
      if (row) setBusy(row, true);
      theme.StoreLists.popups.wishlist.update(theme.Popups.getByName('wishlist'));
    }
  }, true);
})();
